<template>
  <div
    class="bg-[#161616] rounded-[16px] text-white mb-[24px] md:mb-[40px] px-[20px] md:px-[32px] py-[20px] flex flex-col md:flex-row gap-[24px] md:gap-[16px] md:items-center"
    :class="{ 'cursor-pointer': isMobile }"
    @click="handleBannerClick"
  >
    <div class="w-full">
      <p class="font-aktiv-grotesk font-bold leading-[32px] text-[24px]">
        What's Next after GIC 2?
      </p>
      <ul class="font-aktiv-grotesk leading-[28px] text-[20px] custom-list">
        <li>
          Join the GenerationS Pastors Conference in Singapore
          <span
            ><img
              src="../../public/assets/images/singaporeFlag.png"
              alt="singaporeFlag"
              class="inline w-[20px]"
          /></span>
        </li>
      </ul>
    </div>
    <div
      class="flex justify-center md:justify-end w-full md:w-auto"
      @click="handleButtonClick"
    >
      <div
        class="font-aktiv-grotesk font-bold text-[20px] leading-[24px] rounded-full px-[20px] py-[16px] bg-[#FF6600] whitespace-nowrap"
      >
        Find out more
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatsNextBanner",
  data() {
    return {
      isMobile: window.innerWidth < 768, // Tailwind's 'md' breakpoint is 768px
    };
  },
  methods: {
    handleBannerClick() {
      if (this.isMobile) {
        this.$router.push("/whats-next");
      }
    },
    handleButtonClick() {
      if (!this.isMobile) {
        this.$router.push("/whats-next");
      }
    },
    updateScreenWidth() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
};
</script>
<style scoped>
ul.custom-list {
  list-style: none; /* Remove default bullets */
}

ul.custom-list li {
  position: relative; /* Establish a positioning context */
  padding-left: 1rem; /* Add padding to create space for the bullet */
}

ul.custom-list li::before {
  content: "•"; /* Unicode character for bullet */
  font-size: 1.5rem; /* Set bullet size */
  color: white; /* Set bullet color to white */
  position: absolute; /* Position the bullet absolutely */
  left: 0; /* Align the bullet to the left edge of the li */
}
</style>
